/**
 * DeviceDiagnostics — Etapa 9 (Principais motivos / Diagnóstico).
 *
 * Seção SOMENTE LEITURA com os principais motivos de saúde do device.
 * Reusa a API existente healthExplain(deviceId) (mesma origem que o
 * popup antigo usava). Render defensivo: carregando / lista / vazio /
 * erro-oculto. Sem nenhuma ação de escrita.
 */
import { useEffect, useState } from "react";
import { healthExplain } from "../../lib/api.js";

const SEV = {
  critical: { color: "#FF5063", rank: 0 },
  warning:  { color: "#FFB224", rank: 1 },
  info:     { color: "#94a3b8", rank: 2 },
};

export default function DeviceDiagnostics({ deviceId, max = 5 }) {
  const [reasons, setReasons] = useState([]);
  const [state, setState] = useState("loading"); // loading | ok | error

  useEffect(() => {
    if (!deviceId) return;
    let alive = true;
    const ctrl = new AbortController();
    setState("loading");
    setReasons([]);
    healthExplain(deviceId, { signal: ctrl.signal })
      .then((r) => {
        if (!alive) return;
        setReasons(Array.isArray(r?.reasons) ? r.reasons : []);
        setState("ok");
      })
      .catch(() => {
        if (!alive) return;
        setState("error");
      });
    return () => {
      alive = false;
      ctrl.abort();
    };
  }, [deviceId]);

  // Erro/404 → seção some por completo (sem ruído).
  if (state === "error") return null;

  const sorted = [...reasons]
    .sort((a, b) => (SEV[a.severity]?.rank ?? 9) - (SEV[b.severity]?.rank ?? 9))
    .slice(0, max);

  return (
    <div className="ipwd-rp-section">
      <div className="ipwd-rp-section-title">Diagnóstico</div>
      {state === "loading" ? (
        <div className="ipwd-rp-loading">carregando…</div>
      ) : sorted.length === 0 ? (
        <div className="ipwd-rp-na">Nenhum motivo crítico identificado</div>
      ) : (
        <div className="ipwd-diag-list">
          {sorted.map((r, i) => (
            <div
              key={r.code || i}
              className="ipwd-diag-item"
              title={r.detail || ""}
            >
              <span
                className="ipwd-diag-dot"
                style={{ background: SEV[r.severity]?.color || "#94a3b8" }}
              />
              <span className="ipwd-diag-label">{r.label || r.code || "—"}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
